import React from "react";
import "./PageHelp.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";

export default class PageHelp extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<div id={"PageHelp"}>
				<div className="top-separator"/>

				<div className="page max-sized-page">
					<div className="row row-spaced">
						<div className="col-md-12">
							<Breadcrumb>
								<Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
								<Breadcrumb.Item><Link to="/help">Need help?</Link></Breadcrumb.Item>
							</Breadcrumb>
						</div>
					</div>
				</div>

				<div className="page max-sized-page">
					<div className="row row-spaced">
						<div className="col-md-12 row-spaced">
							The goal of LHC’s public mission is to help citizens and businesses
							improve their cyber-protection. While a wide range of services
							and tools are available through the 2 centres hosted by
							LHC, CIRCL and NC3, you will find below a comprehensive list
							of public service helplines.
						</div>
					</div>
				</div>
			</div>
		);
	}
}
